import { useCallback } from 'react';
// @mui
import Card from '@mui/material/Card';
import { CardContent, CardHeader, List } from '@mui/material';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// hooks
// components
import { useTable } from 'src/components/table';
// types
//
import SubAccountTableRow from './sub-account-table-row';
import { useLocales } from '../../../locales';
import { AccountDto } from '../../../api';

// ----------------------------------------------------------------------

type Props = {
  subAccounts: AccountDto[];
};

// ----------------------------------------------------------------------

export default function SubAccountList({ subAccounts }: Props) {
  const { t } = useLocales();

  const TABLE_HEAD = [{ id: 'fullName', label: t('Name'), align: 'left' }, { id: '' }];

  useTable({
    defaultOrderBy: TABLE_HEAD[0].id,
  });

  const router = useRouter();

  const tableData = subAccounts;

  const handleViewRow = useCallback(
    (id: number) => {
      router.push(paths.members.view(id));
    },
    [router]
  );

  return (
    <Card>
      <CardHeader title={t('Sub accounts')} />

      <CardContent>
        <List>
          {tableData?.map((row) => (
            <SubAccountTableRow key={row.id} row={row} onViewRow={() => handleViewRow(row.id!)} />
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

// ----------------------------------------------------------------------
